'use client'

import { ButtonDefault } from '@/components/common/Button'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { usePage } from '@/components/providers/PageProvider'
import { useLinkInternal } from '@/hooks/useLinkInternal'

import styles from './LandsButtons.module.scss'

export const LandsButtons = () => {
  const { page } = usePage()
  const { buildRelative } = useLinkInternal()

  const subsetSlug = page?.route?.subsetSlug

  const hrefCycle = buildRelative({ section: 'landsList', subsetSlug: undefined })
  const hrefName = buildRelative({ section: 'landsList', subsetSlug: 'name' })
  const hrefPopularity = buildRelative({ section: 'landsList', subsetSlug: 'popularity' })

  return (
    <div className={styles.container}>
      <ButtonDefault
        as='LinkRoute'
        colorScheme='content'
        href={hrefCycle}
        size='lg'
        variant={subsetSlug ? 'outline' : undefined}
      >
        <IconWithLabel iconBefore='type-land'>By Cycle</IconWithLabel>
      </ButtonDefault>
      <ButtonDefault
        as='LinkRoute'
        colorScheme='content'
        href={hrefName}
        size='lg'
        variant={subsetSlug === 'name' ? undefined : 'outline'}
      >
        <IconWithLabel iconBefore='font'>By Name</IconWithLabel>
      </ButtonDefault>
      <ButtonDefault
        as='LinkRoute'
        colorScheme='content'
        href={hrefPopularity}
        size='lg'
        variant={subsetSlug === 'popularity' ? undefined : 'outline'}
      >
        <IconWithLabel iconBefore='percent'>By Popularity</IconWithLabel>
      </ButtonDefault>
    </div>
  )
}
